(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-rich-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const track = gallery.querySelector('[data-gallery-track]');
      const panels = [...gallery.querySelectorAll('[data-gallery-panel]')];
      const controls = [...gallery.querySelectorAll('[data-gallery-go]')];
      const previous = gallery.querySelector('[data-gallery-prev]');
      const next = gallery.querySelector('[data-gallery-next]');
      const status = gallery.querySelector('[data-gallery-status]');
      let index = 0;
      let queued = false;
      const update = () => {
        index = Math.max(0, Math.min(panels.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        controls.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        previous.disabled = index === 0;
        next.disabled = index === panels.length - 1;
        status.textContent = `${index + 1} / ${panels.length}`;
      };
      const go = target => {
        const position = Math.max(0, Math.min(panels.length - 1, target));
        track.scrollTo({left: position * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      controls.forEach((button, i) => button.addEventListener('click', () => go(i)));
      previous.addEventListener('click', () => go(index - 1));
      next.addEventListener('click', () => go(index + 1));
      track.addEventListener('scroll', () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => { update(); queued = false; });
      }, {passive:true});
      track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        go(event.key === 'Home' ? 0 : event.key === 'End' ? panels.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
      });
      new ResizeObserver(() => { track.scrollTo({left:index * track.clientWidth,behavior:'instant'}); update(); }).observe(track);
      update();
    });
  };
  document.addEventListener('shopify:section:load', event => init(event.target));
  init();
})();
